<template>
  <div>
    <p>&#x203B; 表示金額はすべて税抜き価格となっております。</p>
    <div class="get-free-delivery">
      <h3>送料無料特典</h3>
      <div v-if="order.city === null">
        配達先住所を入力してください。
      </div>
      <div v-else-if="calculationResult.need_to_be_free_delivery >= 0">
        <p>
          <span class="new-line">お料理の金額が</span>
          <span class="new-line">あと<span class="hoge">{{calculationResult.need_to_be_free_delivery | currency}}分</span>で</span>
          <span class="piyo">送料({{calculationResult.delivery_price | currency}})無料!!</span>
        </p>
        <p class="caution">
          &#x203B; お料理以外の料金は上記に含まれません。
        </p>
      </div>
      <div class="text-danger font-size-large" v-else>
        送料({{calculationResult.delivery_regular_price | currency}})が無料になりました！
      </div>
    </div>

    <!-- 選択したプラン -->
    <div class="block">
      <h2>選択中のプラン</h2>
      <div class="row">
        <div class="col-12">
          <div class="selected-plan">
            <div class="mb-2">
              <span class="label label-order_type">{{orderTypeJa[orderProps.order_type]}}</span>
              <span class="label label-meal_type">{{mealTypeJa[orderProps.meal_type]}}</span>
            </div>
            <h3>
              {{orderProps.plan_name}}
              <span style="font-weight: normal">{{orderProps.plan_price | currency}}</span>
            </h3>
            <dl>
              <dt>最低注文人数</dt>
              <dd>{{orderProps.minimum_quantity}}人</dd>
            </dl>
            <dl v-if="order.order_type === 'catering'">
              <dt>最低注文人数(ドリンク注文時)</dt>
              <dd>{{orderProps.minimum_quantity_with_drink_plan}}人</dd>
            </dl>
            <div class="customer-caution" v-if="orderProps.customer_caution">
              <dd>{{orderProps.customer_caution}}</dd>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ul class="errors alert alert-danger" v-if="errors.fullMessages.length > 0">
      <li v-for="message in errors.fullMessages">{{message}}</li>
    </ul>

    <form>
      <div id="order-information" class="block">
        <!-- 人数 -->
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">人数</label>
              <input name="quantity" class="form-control" type="number" min="1"
                     v-model="order.quantity"
                     @input="calculate(); validatesQuantity()"
                     @change="updatePlateQuantity"
                     inputmode="numeric">
              <ul class="errors alert alert-danger mt-2" v-if="errors.messages.quantity.length > 0">
                <li v-for="message in errors.messages.quantity">{{message}}</li>
              </ul>
            </div>
          </div>

          <!--場所 -->
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達先住所（都道府県）</label>
              <select name="prefecture" v-model="order.prefecture" class="form-control" @change="changePrefecture">
                <option disabled value="">都道府県を選択</option>
                <option v-for="prefecture in ['東京都', '神奈川県', '埼玉県', '千葉県']">{{prefecture}}</option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達先住所（市区）</label>
              <select name="city" class="form-control" v-model="order.city" @change="calculate">
                <option disabled value="">市区を選択</option>
                <option v-for="priceTable in filteredDeliveryPriceTable">{{priceTable.attributes.city}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- 料理内容変更 -->
      <div id="change-dish" class="block" v-if="plan.customizations && plan.customizations.length > 0">
        <h2>料理内容変更</h2>
        <p>
          ご希望のものにチェックを入れてください。<br>
          <span class="text-danger">追加料金ありの項目は、人数 × 単価で金額が反映されます。</span>
        </p>
        <div class="option-area">
          <div class="row mb-2" v-for="customization in plan.customizations" :key="customization.id">
            <div class="col-12">
              <label>
                <input type="checkbox"
                       :value="customization.id"
                       :checked="isCustomizationSelected(customization.id)"
                       @change="handleCustomization(customization, $event.target.checked)">
                <span class="font-size-large">{{customization.description}}</span>
                <span class="ml-2" v-if="Number(customization.price) > 0">
                  <span class="text-danger">+{{customization.price | currency}}/人</span>
                </span>
                <span class="ml-2 text-muted" v-else>無料</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- ドリンク類 -->
      <template v-if="drinkAvailable && order.order_type === 'delivery'">
        <!-- オードブルの場合、23区内以外はカクヤスが配達できないためドリンクの注文は不可 -->
        <template v-if="order.prefecture === '東京都' && order.city && order.city.includes('区')">
          <div class="block">
            <!-- ドリンクセット -->
            <div id="drink-sets" class="row">
              <div class="col-12">
                <h2>ドリンクセットの追加はこちら</h2>
                <div class="option-area">
                  <p>
                    ドリンクセットの追加はこちらから。セット入力で料金に反映されます。<br>
                    <span class="text-danger">未成年の方にアルコールのご提供はできません。</span>
                  </p>
                  <div class="option-list">
                    <DrinkSetOption
                        v-for="(drinkSet, index) in drinkSetOptions"
                        :key="index"
                        :drinkSet="drinkSet"
                        :initialQuantity="carriedQuantity('drink_sets', drinkSet)"
                        @calculate="calculate"
                        @handleDrinkSet="handleDrinkSet"
                    ></DrinkSetOption>
                  </div>
                </div>
              </div>
            </div>

            <!-- ドリンク(単品) -->
            <div id="drinks" class="row mt-4">
              <div class="col-12">
                <h2>ドリンク(単品)の追加はこちらから</h2>
                <div class="option-area">
                  <p>
                    ドリンクの追加はこちらから。必要本数入力で料金に反映されます。<br>
                    <span class="text-danger">未成年の方にアルコールのご提供はできません。</span>
                  </p>
                  <div class="option-list">
                    <DrinkOption
                        v-for="(drink, index) in drinkOptions.filter(option => option.kind !== 'other')"
                        :key="index"
                        :drink="drink"
                        :initialQuantity="carriedQuantity('drinks', drink)"
                        @calculate="calculate"
                        @handleDrink="handleDrink"
                    ></DrinkOption>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <div class="alert alert-danger" v-if="order.drinks.find(drink => drink.kind === 'alcohol') || order.drink_sets.length > 0">
                  <input id="alcohol_policy_agreement" name="alcohol_policy_agreement" type="checkbox" v-model="order.alcohol_policy_agreement">
                  <label for="alcohol_policy_agreement" class="font-size-large">20歳以上です</label>
                  <div>&#x203B; 未成年者の飲酒は法律で禁じられております。上記チェックがない場合はお酒のデリバリーは行えませんのでご了承くださいませ。</div>
                </div>
              </div>
            </div>

            <!-- 備品 -->
            <div id="equipments" class="row mt-4">
              <div class="col-12">
                <h2>備品の追加はこちらから</h2>
                <div class="option-area">
                  <p> 備品の追加はこちらから。人数入力で料金に反映されます。 </p>
                  <div class="option-list">
                    <DrinkOption
                        v-for="(drink, index) in drinkOptions.filter(option => option.kind === 'other')"
                        :key="index"
                        :drink="drink"
                        :initialQuantity="carriedQuantity('drinks', drink)"
                        @calculate="calculate"
                        @handleDrink="handleDrink"
                    ></DrinkOption>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row">
            <div class="col-12">
              <h2>ドリンクはこちらから</h2>
              <div class="alert alert-danger">
                オードブルの場合、ドリンクの注文は23区内のみ可能となります。
              </div>
            </div>
          </div>
        </template>
      </template>

      <!-- ドリンクプラン -->
      <div v-if="order.order_type === 'catering'" id="drink-plan" class="block">
        <div class="row">
          <div class="col-12">
            <h2>飲み放題（ドリンクプラン）</h2>
            <!-- 飲み放題は最初から「つける」。人数を入れると、選んだ飲み放題に同じ人数が自動で入る(2026-10-12〜)。
                 細かく人数を分けたいときは、下の一覧で直せる -->
            <div class="drink-plan-default">
              <p class="mb-2">
                ケータリングのお客様の約8割が飲み放題をつけています。ドリンクカップ・氷・ドリンクの用意から片付けまでお任せください。
              </p>
              <div class="radio-button-inline">
                <div class="radio-button-box">
                  <input id="drink-plan-on" type="radio" :value="true" v-model="drinkPlanOn">
                  <label for="drink-plan-on">飲み放題をつける（おすすめ）</label>
                </div>
                <div class="radio-button-box">
                  <input id="drink-plan-off" type="radio" :value="false" v-model="drinkPlanOn">
                  <label for="drink-plan-off">つけない（お料理のみ）</label>
                </div>
              </div>
              <div v-if="drinkPlanOn" class="drink-plan-choices">
                <label v-for="drinkPlan in drinkPlanOptions" :key="'choice-' + drinkPlan.id" class="drink-plan-choice">
                  <input type="radio" :value="drinkPlan.id" v-model="selectedDrinkPlanId">
                  <span>{{drinkPlan.name}}</span>
                  <span class="text-muted ml-1">{{drinkPlan.price | currency}}/人</span>
                </label>
                <p class="text-muted small mb-0" v-if="order.quantity > 0">
                  お料理と同じ {{order.quantity}}人分で計算しています。人数を分けたい場合は下の欄で直せます。
                </p>
                <p class="text-muted small mb-0" v-else>人数を入れると、同じ人数分の飲み放題が自動で入ります。</p>
              </div>
            </div>
            <div class="option-area" v-show="drinkPlanOn">
              <p>
                <span class="text-danger mt-3">
                  ドリンクプランをご注文の場合、お料理の人数分の注文をお願いしております。(人数以下をご希望の場合はご相談ください)
                  <br>
                  未成年の方にアルコールのご提供はできません。
                </span>
              </p>
              <!-- <div v-if="drinkPlanMinimumQuantityWarning" class="alert alert-danger">ドリンクセットをご注文の場合、お料理の人数分の注文が必要です。</div> -->
              <ul class="alert alert-danger" v-if="invalidDrinkPlanCombinationMessages.length > 0">
                <li v-for="message in invalidDrinkPlanCombinationMessages">{{message}}</li>
              </ul>
              <div class="option-list">
                <DrinkPlanOption
                    v-for="(drinkPlan, index) in drinkPlanOptions"
                    :key="index"
                    :drinkPlan="drinkPlan"
                    :initialQuantity="prefillDrinkPlanQuantity(drinkPlan)"
                    :syncedQuantity="syncedDrinkPlanQuantity(drinkPlan)"
                    @calculate="calculate"
                    @validatesQuantity="validatesQuantity"
                    @handleDrinkPlan="handleDrinkPlan"
                ></DrinkPlanOption>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 追加料理 -->
      <div id="dishes" class="block" v-if="['buffet', 'finger'].includes(order.meal_type)">
        <div class="row">
          <div class="col-12">
            <h2>追加料理はこちらから</h2>
            <div class="option-area">
              <p>
                料理の追加はこちらから。人数入力で料金に反映されます。<br>
                <span class="text-danger" v-if="order.quantity">{{dishMinimumQuantity}}名以上のご注文をお願いしております。</span>
              </p>
              <div class="option-list">
                <DishOption
                    v-for="(dish, index) in dishOptions"
                    :key="index"
                    :dish="dish"
                    :initialQuantity="carriedQuantity('dishes', dish)"
                    :minimumQuantity="dishMinimumQuantity"
                    @calculate="calculate"
                    @handleDish="handleDish"
                ></DishOption>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 取皿　発熱剤　テーブルクロスの利用 -->
      <div id="option">
        <div class="block" v-if="order.order_type === 'delivery' && ['buffet', 'finger'].includes(order.meal_type)">
          <div class="mb-3">
            <h2>取皿セットの利用</h2>
            <div class="row mb-3">
              <div class="col-12 col-md-6 d-flex">
                <div class="radio-button-box">
                  <input id="use-plate-true" name="use_plate" type="radio" :value="true" v-model="order.use_plate" @change="calculate">
                  <label for="use-plate-true">使用する</label>
                </div>
                <div class="radio-button-box">
                  <input id="use-plate-false" name="use_plate" type="radio" :value="false" v-model="order.use_plate" @change="calculate">
                  <label for="use-plate-false">使用しない</label>
                </div>
              </div>
            </div>
            <div class="row mb-3" v-if="order.use_plate">
              <div class="col-12 col-md-4">
                <div class="input-group">
                  <input name="plate_quantity" type="number" min="1" v-model="order.plate_quantity" @input="calculate" class="form-control" placeholder="ご希望の数を入力" inputmode="numeric">
                  <div class="input-group-append">
                    <span class="input-group-text">セット</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p class="order-note-box">
                  【・お箸・取り皿・おしぼり・紙トング】
                  <br>
                  の四点セットを、お一人様30円にてご提供させていただいております。
                  <br>
                  &#x203B; 取皿セット不要の場合はトングも付きません。
                </p>
              </div>
            </div>
          </div>

          <div v-if="plan.required_exothermic_agent_quantity > 0 && ['type1', 'type2'].includes(plan.exothermic_agent_quantity_calculation_type)">
            <h2>発熱剤の利用</h2>
            <p>
              料理を温めるものです。(1皿300円)
              <a href="https://catering-season.com/exothermic-agent" target="_blank">発熱剤の使い方はこちら</a>
            </p>
            <div class="row">
              <div class="col-12 col-md-6 d-flex">
                <div class="radio-button-box">
                  <input id="exothermic-agent-true" name="exothermic_agent" type="radio" v-model="order.use_exothermic_agent" :value="true" @change="calculate">
                  <label for="exothermic-agent-true">使用する</label>
                </div>
                <div class="radio-button-box">
                  <input id="exothermic-agent-false" name="exothermic_agent" type="radio" v-model="order.use_exothermic_agent" :value="false" @change="calculate">
                  <label for="exothermic-agent-false">使用しない</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="block" v-if="order.order_type === 'catering'">
          <div class="row">
            <div class="col-12">
              <h2>テーブルクロスの利用</h2>
              <p>50名様につき1,000円（税抜）にて必要枚数をご用意します。</p>
              <p>
                こちらが用意した料理とドリンクをご提供するテーブルのみにおつけします。<br>
                準備時間が短い場合やテーブルの形状によっては、テーブルクロスをおつけできない場合がございます。
              </p>
            </div>

            <div class="col-12 col-md-6">
              <div class="radio-button-inline">
                <div class="radio-button-box">
                  <input id="use-tablecloth-true" type="radio" :value="true" v-model="order.use_tablecloth" @change="calculate">
                  <label for="use-tablecloth-true">使用する</label>
                </div>
                <div class="radio-button-box">
                  <input id="use-tablecloth-false" type="radio" :value="false" v-model="order.use_tablecloth" @change="calculate">
                  <label for="use-tablecloth-false">使用しない</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 見積り -->
      <div class="block">
        <div class="quick-estimate-wrapper">
          <!-- 100名以上のとき、特典が自動で付いていることを1行で知らせる(2026-10-24)。
               /large/ への入口は出さない。設置・撤収料金(派遣料)0円は /large/ のボタンから来た注文だけ、という
               2026-10-04 の maki さん決定を変えないため。/large/ から来た注文(large_order_page_referral)には見積りの行で分かるので出さない -->
          <p v-if="largeOrderNotice" class="large-order-notice">
            100名様以上のご注文のため、<strong>100名以上特典</strong>（{{largeOrderNotice}}）がこのお見積りに自動で付いています。
          </p>
          <EstimateField
              :order="order"
              :calculationResult="calculationResult"
          ></EstimateField>

          <!-- 1つ上のプランにしたときの差額を1行で出す(2026-10-24 売上施策③)。基準は今のプラン、出すのは1つ上だけ。
               金額は今の見積りと同じ条件(人数・飲み放題・追加料理など)で 1つ上のプランを計算した本物の値。いちばん上のプランには出ない -->
          <div v-if="planUpgrade" class="plan-upgrade">
            <span class="plan-upgrade-label">1つ上のプラン</span>
            <span class="plan-upgrade-text">
              {{upgradePlan.name}}（{{upgradePlan.price | currency}}／人・税抜）にすると、1人あたり <strong>＋{{planUpgrade.diffPerPerson | currency}}</strong>、合計 <strong>＋{{planUpgrade.diff | currency}}</strong>（税込）
            </span>
            <a :href="planUpgrade.url" class="plan-upgrade-link" @click="trackPlanUpgrade">{{upgradePlan.name}}で見積りを見る →</a>
            <span class="plan-upgrade-note">人数・飲み放題・住所など、入力した内容はそのまま引き継ぎます。</span>
          </div>

          <!-- オードブルで人数がケータリングの最低人数以上なら、同じプランのスタッフ付き(ケータリング)を提案する(2026-10-12 売上施策②)。
               金額は料理のみのケータリングを同じ条件で計算した本物の値 -->
          <div v-if="cateringSuggestion" class="catering-suggestion">
            <h3>{{order.quantity}}名様なら、スタッフ付きのケータリングも選べます</h3>
            <p>
              スタッフが会場で料理を並べ、終わったあとの片付けとゴミの回収まで行います。お客様は当日、会場に集まるだけです。
            </p>
            <table class="catering-suggestion-table">
              <tr>
                <td>今のお見積り（オードブル）</td>
                <td>{{calculationResult.total_price | currency}}（税込）</td>
              </tr>
              <tr>
                <td>スタッフ付き（{{cateringAlternative.name}}・お料理のみ）</td>
                <td>
                  <strong>{{cateringSuggestion.total | currency}}</strong>（税込）
                  <span class="catering-suggestion-diff">＋{{cateringSuggestion.diff | currency}}（1人あたり ＋{{cateringSuggestion.diffPerPerson | currency}}）</span>
                </td>
              </tr>
              <tr v-if="defaultDrinkPlan">
                <td>飲み放題（{{defaultDrinkPlan.name}}）を付けると</td>
                <td>さらに ＋{{defaultDrinkPlan.price | currency}}／人（税抜）</td>
              </tr>
            </table>
            <a :href="cateringSuggestion.url" class="btn btn-outline-primary mt-2" @click="trackCateringSuggestion">
              スタッフ付きで見積りを見る →
            </a>
            <p class="small text-muted mt-2 mb-0">人数はそのまま引き継ぎます。配達先はもう一度選んでください。今の画面はそのまま注文に進めます。</p>
          </div>

          <!-- 見積りモーダル -->
          <button @click.prevent="showEstimateModal" class="mt-2 btn btn-primary">見積書を確認</button>
          <Modal title="見積もり" v-if="shouldShowEstimateModal" @close="hideEstimateModal">
            <Estimate
                :order="order"
                :calculationResult="calculationResult"
                @downloadEstimate="downloadEstimate"
            ></Estimate>
          </Modal>
        </div>
      </div>

      <!-- 配達情報 -->
      <div id="delivery-date" class="block">
        <h2>配達日時</h2>

        <!-- 配達日時(ケータリング） -->
        <div class="row" v-if="order.order_type === 'catering'">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達日</label>
              <Datepicker
                  name='catering_on'
                  :language="ja"
                  :disabled-dates="disabledDates"
                  format="yyyy年MM月dd日(D)"
                  input-class="form-control datepicker"
                  v-model="order.catering_on"
              >
              </Datepicker>
              <p class="small text-muted mt-1 mb-0" v-if="yearEndHolidayNote">{{ yearEndHolidayNote }}</p>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">開始予定時間</label>
              <select name="catering_start_at" class="form-control" v-model="order.catering_start_at">
                <option disabled value="">開始予定時間を選択</option>
                <option v-for="time in timeOptions(11, 20)" :value="time">{{time}}</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">終了予定時間</label>
              <select name="catering_end_at" class="form-control" v-model="order.catering_end_at">
                <option disabled value="">終了予定時間を選択</option>
                <option v-for="time in timeOptions(11, 22)" :value="time">{{time}}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- 配達日時(オードブル） -->
        <div class="row" v-if="order.order_type === 'delivery'">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="required">配達日</label>
              <Datepicker
                  name='delivery_on'
                  :language="ja"
                  :disabled-dates="disabledDates"
                  format="yyyy年MM月dd日(D)"
                  input-class="form-control datepicker"
                  v-model="order.delivery_on"
              ></Datepicker>
              <p class="small text-muted mt-1 mb-0" v-if="yearEndHolidayNote">{{ yearEndHolidayNote }}</p>
              <template v-if="isSeventeenPassed">
                <div class="alert alert-danger mt-2">翌日のご予約をご希望の場合はご注文をお受けできない場合がございます。予約送信後にお電話でご相談ください。</div>
              </template>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達時間</label>
              <select name="delivery_time_range" class="form-control" v-model="order.delivery_time_range">
                <option disabled value="">配達時間を選択</option>
                <option v-for="time in timeRangeOptions(10, 20)" :value="time">{{time}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- ご利用シーン（任意）。選択肢は選んだ配達日の月で変わる（12月なら忘年会など） -->
      <div id="order-scene" class="block">
        <h2>どのような集まりでご利用ですか？<span class="ml-2" style="font-size:13px;font-weight:normal;">（任意）</span></h2>
        <!-- おまけの設問なので1行に収める。「その他」のときだけ右に自由記述が出る -->
        <div class="scene-row">
          <select class="form-control scene-select" v-model="order.scene">
            <option value="">選択してください</option>
            <option v-for="opt in sceneOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
          </select>
          <input v-if="order.scene === 'other'" type="text" class="form-control scene-note" maxlength="255"
                 placeholder="例：イベントの打ち上げ、慰労会"
                 v-model="order.scene_note">
        </div>
      </div>

      <div id="delivery-address" class="block">
        <h2>配達住所</h2>
        <!--場所 -->
        <div class="row">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達先住所（都道府県）</label>
              <select name="prefecture" v-model="order.prefecture" class="form-control" @change="changePrefecture">
                <option disabled value="">都道府県を選択</option>
                <option v-for="prefecture in ['東京都', '神奈川県', '埼玉県', '千葉県']">{{prefecture}}</option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達先住所（市区）</label>
              <select name="city" class="form-control" v-model="order.city" @change="calculate">
                <option disabled value="">市区を選択</option>
                <option v-for="priceTable in filteredDeliveryPriceTable">{{priceTable.attributes.city}}</option>
              </select>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="required">配達先住所（町村・番地）</label>
              <input name="address" class="form-control" type="text" v-model="order.address" placeholder="例) 水道2-1-19">
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>配達先住所（建物名）※階数や部屋番号も必ずご入力ください</label>
              <input name="building_name" class="form-control" type="text" v-model="order.building_name" placeholder="例) モンフェリーチェ1階">
            </div>
          </div>
        </div>
      </div>

      <!-- お客様情報 -->
      <div id="customer-information" class="block">
        <h2>お客様情報</h2>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="required">ご担当者名</label>
              <input name="customer_name" type="text" class="form-control" v-model="order.customer_name">
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group">
              <label>法人名・団体名</label>
              <input name="group_name" type="text" class="form-control" v-model="order.group_name">
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="required">電話番号</label>
              <input name="tel" type="text" class="form-control" v-model="order.tel" inputmode="tel">
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="required">メールアドレス</label>
              <input name="email" type="text" class="form-control" v-model="order.email" :disabled="this.currentCustomer" inputmode="email">
            </div>
          </div>
        </div>
      </div>

      <!-- 支払い方法 & 注文に関するご要望・ご質問 -->
      <div id="payment-information" class="block">
        <h2>お支払い情報</h2>
        <!-- 支払い方法 -->
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="required">支払い方法</label>
              <select class="form-control" name="payment_method" v-model="order.payment_method">
                <option disabled value="">支払い方法を選択</option>
                <option v-for="(v, k) in paymentMethodOptions" :value="k">{{v}}</option>
              </select>
            </div>
          </div>
        </div>

        <template v-if="['before_bank_transfer', 'later_bank_transfer'].includes(order.payment_method)">
          <div class="row mt-3">
            <!-- 請求書宛名 -->
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>請求書の宛名</label>
                <span class="d-block">指定がない場合は「法人名・団体名」を記載します。</span>
                <input type="text" class="form-control" v-model="order.invoice_address">
              </div>
            </div>
          </div>
        </template>

        <template v-if="['cash', 'pay'].includes(order.payment_method)">
          <div class="row mt-3">
            <div class="col-12 col-md-6 mb-1">
              <div class="required font-weight-bolder mb-1">領収書の要否</div>
              <div class="d-flex">
                <div class="radio-button-box">
                  <input id="need-receipt-true" name="need_receipt" type="radio" :value="true" v-model="order.need_receipt">
                  <label for="need-receipt-true">必要</label>
                </div>
                <div class="radio-button-box">
                  <input id="need-receipt-false" name="need_receipt" type="radio" :value="false" v-model="order.need_receipt">
                  <label for="need-receipt-false">不要</label>
                </div>
              </div>
            </div>
          </div>

          <template v-if="order.need_receipt">
            <div class="row mt-3">
              <!-- 領収書但し書き -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>領収書の但し書きの指定がある場合は入力して下さい</label>
                  <span class="d-block">指定がない場合は「ケータリング代」と記載します。</span><br>
                  <input name="receipt_proviso" type="text" class="form-control" v-model="order.receipt_proviso" placeholder="例) ケータリング代">
                </div>
              </div>

              <!--領収書宛名指定 -->
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>領収書の宛名の指定がある場合は入力して下さい</label>
                  <span class="d-block">指定がない場合は、「法人名・団体名」が入力されている場合は「法人名・団体名」を記載します。「法人名・団体名」の入力がない場合は「ご担当者様」のお名前を記載いたします。</span>
                  <input name="receipt_address" type="text" class="form-control" v-model="order.receipt_address" placeholder="例) 鈴木 一郎">
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>

      <div class="block">
        <!-- ご注文に関するご要望・ご質問 -->
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>ご注文に関するご要望・ご質問</label>
              <textarea class="form-control" rows="3" v-model="order.request"></textarea>
            </div>
          </div>
        </div>
      </div>

      <!-- 会場情報 -->
      <div id="about-venue" class="block" v-if="order.order_type === 'catering'">
        <div class="row">
          <div class="col-12 mb-1">
            <div class="my-2 order-note-box">
              
              
            </div>
          </div>
        </div>
        <h2>会場情報</h2>
        <div class="row mb-3">
          <div class="col-12 col-md-6 mb-1">
            <div class="d-flex">
              <div class="radio-button-box">
                <input id="input-yourself-true" type="radio" value="input_yourself" v-model="about_venue">
                <label for="input-yourself-true">いま入力する</label>
              </div>
              <div class="radio-button-box">
                <input id="input-yourself-false" type="radio" value="contact_me" v-model="about_venue">
                <label for="input-yourself-false">あとで入力する</label>
              </div>
            </div>
          </div>
        </div>

        <template v-if="about_venue === 'contact_me'">
          <div class="my-2 order-note-box">
            予約リクエスト送信後にメールをお送りします。<br>
            入力画面からご入力お願いいたします。
          </div>
        </template>
        <template v-if="about_venue === 'input_yourself'">
          <div class="row">
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">入館手続き</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-admission-procedure-true" name="catering_admission_procedure" type="radio" :value="true" v-model="order.catering_admission_procedure">
                    <label for="catering-admission-procedure-true">必要</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering-admission-procedure-false" name="catering_admission_procedure" type="radio" :value="false" v-model="order.catering_admission_procedure">
                    <label for="catering-admission-procedure-false">不要</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">エレベーター</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-elevator-true" name="catering_elevator" type="radio" :value="true" v-model="order.catering_elevator">
                    <label for="catering-elevator-true">有り</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering-elevator-false" name="catering_elevator" type="radio" :value="false" v-model="order.catering_elevator">
                    <label for="catering-elevator-false">無し</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">台車</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-wagon-true" name="catering_wagon" type="radio" :value="true" v-model="order.catering_wagon">
                    <label for="catering-wagon-true">可</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering-wagon-false" name="catering_wagon" type="radio" :value="false" v-model="order.catering_wagon">
                    <label for="catering-wagon-false">不可</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">固形燃料の使用</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-solid-fuel-using-true" name="catering_solid_fuel_using" type="radio" :value="true" v-model="order.catering_solid_fuel_using">
                    <label for="catering-solid-fuel-using-true">可</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering-solid-fuel-using-false" name="catering_solid_fuel_using" type="radio" :value="false" v-model="order.catering_solid_fuel_using">
                    <label for="catering-solid-fuel-using-false">不可</label>
                  </div>
                </div>
                <p>&#x203B; お料理を温めるのに火を使用しますが、煙は出ません。</p>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">駐車場の有無</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-parking-true" name="catering_parking" type="radio" :value="true" v-model="order.catering_parking">
                    <label for="catering-parking-true">有り</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering-parking-false" name="catering_parking" type="radio" :value="false" v-model="order.catering_parking">
                    <label for="catering-parking-false">無し</label>
                  </div>
                </div>
                <p>駐車料金が発生した場合はお客様負担になります。</p>
              </div>
            </div>

            <div v-if="order.catering_parking" class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <div class="font-weight-bolder mb-1">駐車場料金</div>
                <div class="d-flex">
                  <div class="radio-button-box">
                    <input id="catering-parking-fee-true" name="catering_parking_fee" type="radio" :value="true" v-model="order.catering_parking_fee">
                    <label for="catering-parking-fee-true">有料</label>
                  </div>
                  <div class="radio-button-box">
                    <input id="catering=parking-fee-false" name="catering_parking_fee" type="radio" :value="false" v-model="order.catering_parking_fee">
                    <label for="catering=parking-fee-false">無料</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <label>入室可能時間</label>
                <select name="catering_avalilable_time" v-model="order.catering_avalilable_time" class="form-control">
                  <option disabled value="">入室可能時間を選択</option>
                  <option v-for="time in timeOptions(9, 20)" :value="time">{{time}}</option>
                </select>
                <p class="my-1 small">
                  &#x203B; 準備に最低1時間はかかります。<br>
                  &#x203B; 会の開始時刻より1時間前に設定をお願いいたします。<br>
                  &#x203B; 人数様により1時間以上かかることもございます。
                </p>
              </div>
            </div>
            <div class="col-12 col-md-4 mb-1">
              <div class="form-group">
                <label>完全撤収時間</label>
                <select name="catering_backdown_time" v-model="order.catering_backdown_time" class="form-control">
                  <option disabled value="">撤収時間を選択</option>
                  <option v-for="time in timeOptions(11, 24)" :value="time">{{time}}</option>
                </select>
                <p class="my-1 small">
                  &#x203B; 会の終了後から30分〜1時間片付けにお時間をいただいております。<br>
                  &#x203B; 人数様により片付けのお時間は変わります。
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-12 mb-1">
              <div class="form-group">
                <label>会場についての補足情報</label>
                <textarea name="catering_remarks" v-model="order.catering_remarks" class="form-control"></textarea>
              </div>
            </div>
          </div>
        </template>
      </div>

      <!-- 当日の写真撮影について（任意）。オードブルでも出す(v-if を付けない)。プロ撮影はケータリングのときだけ -->
      <div id="photo-consent" class="block">
        <h2>当日の写真撮影について<span class="ml-2" style="font-size:13px;font-weight:normal;">（任意）</span></h2>
        <div class="row">
          <div class="col-12 mb-1">
            <div class="my-2 order-note-box">
              会場での写真は、ホームページの実績紹介などに使わせていただくことがあります。お顔は写しません（写ってしまった場合はぼかし処理をします）。未選択のままでもご注文いただけます。
            </div>
            <div class="photo-consent-option">
              <input id="photo-consent-check" name="photo_consent" type="checkbox" v-model="order.photo_consent">
              <label for="photo-consent-check">料理と会場の写真を撮ってもよい（お顔は写しません）</label>
            </div>
            <!-- オードブルは通常お客様が準備するため、文をケータリングと分ける（撮影OKなら準備をサービス） -->
            <div v-if="order.order_type === 'delivery'" class="photo-consent-hint">
              通常、届いたお料理を並べるなどの準備はお客様にお願いしていますが、撮影をご了承いただいた場合はスタッフが準備をいたします。準備後にスマホで数枚撮影します。<br>
              ※スタッフの予定が合わない日は、撮影（準備のサービス）を行えない場合があります。
            </div>
            <div v-else class="photo-consent-hint">準備が終わった料理や、取り分けの様子（手元のみ）・パーティーの雰囲気を、スタッフがスマホで数枚撮影します。お客様にお願いすることはありません。</div>

            <div v-if="order.photo_consent && order.order_type === 'catering'" class="pro-photo-box">
              <div class="photo-consent-option">
                <input id="pro-photo-check" name="pro_photo_request" type="checkbox" v-model="order.pro_photo_request">
                <label for="pro-photo-check">プロカメラマンの記念撮影（無料）を希望する</label>
              </div>
              <ul class="pro-photo-notes">
                <li>月3組様限定。プロが撮影した写真データを全カット無料でお渡しします（社内報告や関係者への共有にご自由にお使いください）</li>
                <li>撮影のため、通常より約1時間早く会場に入らせていただきます。会場が早めに使えるかご確認ください</li>
                <li>お顔はぼかし・後ろ姿のみなど、ご希望に合わせます。ホームページへの掲載は、後日写真をご覧いただいてから決めていただけます</li>
                <li>ご希望が重なった場合は、ご相談させていただくことがあります</li>
              </ul>
              <div class="form-group" v-if="order.pro_photo_request">
                <input type="text" class="form-control pro-photo-note" maxlength="255"
                       placeholder="会場に入れる時間など、ご要望があればご記入ください（任意）"
                       v-model="order.pro_photo_note">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- どこで知ったか（任意） -->
      <div id="referral-source" class="block">
        <h2>ケータリングSeasonをどこでお知りになりましたか？<span class="ml-2" style="font-size:13px;font-weight:normal;">（任意）</span></h2>
        <div class="row">
          <div class="col-12 mb-1">
            <div class="my-2 order-note-box">
              今後のご案内の参考にさせていただきます。未選択のままでもご注文いただけます。
            </div>
            <div class="referral-source-options">
              <div class="referral-source-option" v-for="opt in referralSourceOptions" :key="opt.value">
                <input :id="'referral-source-' + opt.value" name="referral_source" type="radio" :value="opt.value" v-model="order.referral_source">
                <label :for="'referral-source-' + opt.value">{{ opt.label }}</label>
              </div>
            </div>
            <div class="form-group mt-2" v-if="order.referral_source === 'other'">
              <input type="text" class="form-control" maxlength="255"
                     placeholder="よろしければ具体的にご記入ください（任意）"
                     v-model="order.referral_source_note">
            </div>
          </div>
        </div>
      </div>

      <div>
                                            <div class="my-2 order-note-box">ご注文の日時や人数によっては、ご希望に添えない場合がございます。</div>         <button @click.prevent="showOrderCautionModal" class="mt-2 btn btn-success" :disabled="!submitable">予約リクエストを送信する</button>         <p class="submit-note">送信後、担当者よりご予約内容を確認のうえ、ご連絡いたします。</p>                                             
        <Modal title="注文の最終確認" v-if="shouldShowOrderCautionModal" @close="hideOrderCautionModal">
          <OrderCaution></OrderCaution>
          <p class="text-danger">&#x203B; 入力内容の確認後、そのままご予約が完了します。</p>
          <p class="delivery-date-warning">
            配達日は<span class="">{{(order.catering_on || order.delivery_on) | moment("YYYY年MM月DD日")}}</span>です。<br>
            配達日をお間違えないようにお願いします。
          </p>
          <input type="submit" value="予約リクエストを送信する" class="btn btn-block btn-success" @click="create">
        </Modal>
      </div>
      <Loading v-show="loading"></Loading>
    </form>
  </div>
</template>

<script>
  import moment from 'moment';
  import Datepicker from 'vuejs-datepicker';
  import { ja } from 'vuejs-datepicker/dist/locale'
  import _ from 'lodash';
  import axios from 'axios';
  import qs from 'qs';
  import { orderTypeJa, mealTypeJa }  from '../../utilities/locale';
  import Modal from './Modal';

  try {
    axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    };
  } catch(e) {
    console.log(e);
  }

  import Loading from "../Loading";

  // 新規注文画面
  import DrinkOption from './options/DrinkOption'
  import DishOption from './options/DishOption'
  import DrinkPlanOption from './options/DrinkPlanOption'
  import DrinkSetOption from './options/DrinkSetOption'

  // 見積
  import Estimate from './Estimate'
  import EstimateField from './EstimateField';
  import OrderCaution from './OrderCaution';
  // 年末年始休業(毎年 12/31〜1/3)。カレンダーで灰色にする。
  // 休業日の一覧と表示用の期間は props(yearEndHolidays / yearEndHolidayLabel)でサーバー(Order::YEAR_END_HOLIDAYS)から受け取る。
  // 期間を変えるときは app/models/order.rb の YEAR_END_HOLIDAY_FROM / TO だけを直せばよい。
  // 下の値は props が渡されなかったときの予備(サーバー側と同じ内容にしておくこと。spec で一致を確かめている)
  const YEAR_END_HOLIDAY_FALLBACK = ['12-31', '1-1', '1-2', '1-3'];
  const YEAR_END_HOLIDAY_LABEL_FALLBACK = '12/31〜1/3';

  // 「1つ上のプランで見積りを見る」で別のプランの画面に移るとき、入力した内容を一時的に覚えておく場所(sessionStorage)と、
  // 引き継ぐ項目。プラン固有のもの(料理内容変更・プラン情報)と人数(URL で渡す)は含めない(2026-10-27)
  const PLAN_UPGRADE_CARRY_KEY = 'season_plan_upgrade_carry'
  const PLAN_UPGRADE_CARRY_FIELDS = [
    'prefecture', 'city', 'address', 'building_name',
    'email', 'tel', 'group_name', 'customer_name', 'payment_method',
    'scene', 'scene_note', 'catering_on', 'delivery_on',
    'referral_source', 'referral_source_note', 'photo_consent', 'pro_photo_request', 'pro_photo_note',
    'need_receipt', 'receipt_proviso', 'receipt_address',
    'catering_start_at', 'catering_end_at', 'delivery_time_range',
    'catering_admission_procedure', 'catering_elevator', 'catering_wagon', 'catering_parking', 'catering_parking_fee',
    'catering_solid_fuel_using', 'catering_avalilable_time', 'catering_backdown_time', 'catering_remarks',
    'use_plate', 'plate_quantity', 'use_exothermic_agent', 'use_tablecloth', 'alcohol_policy_agreement'
  ]

  export default {
    components: {
      Modal,
      Loading,
      DrinkOption,
      DishOption,
      DrinkPlanOption,
      DrinkSetOption,
      Estimate,
      EstimateField,
      OrderCaution,
      Datepicker
    },
    props: {
      paymentMethodOptions: Object,
      statusOptions: Object,
      orderProps: Object,
      handleSubmit: Function,
      deliveryPriceTable: Array,
      currentCustomer: Object,
      // ご利用シーンの選択肢。[{value, label, months}] の形。months があるものは季節限定
      sceneOptionList: Array,
      // おすすめプラン案内ページ(catering-season.com)から URL で引き継いだ飲み放題。{id, quantity} か null
      prefillDrinkPlan: Object,
      // オードブルのとき、同じ内容のケータリングのプラン {plan_id, name, price, minimum_quantity}。無ければ null
      cateringAlternative: Object,
      // ケータリングの既定の飲み放題 {id, name, price}
      defaultDrinkPlan: Object,
      // 1つ上のプラン {plan_id, name, price, minimum_quantity, minimum_quantity_with_drink_plan}。いちばん上のプランなら null(2026-10-24 売上施策③)
      upgradePlan: Object,
      // 年末年始休業の日(毎年同じ「月-日」。例 ['12-31', '1-1', '1-2', '1-3'])と、注意書きに出す期間('12/31〜1/3')。
      // サーバー(Order::YEAR_END_HOLIDAYS)から渡す。空の配列なら休業日なし
      yearEndHolidays: Array,
      yearEndHolidayLabel: String,
    },
    data: function () {
      return {
        // 飲み放題を「つける」か(ケータリングだけ)。prefillDrinkPlan があれば最初から true
        drinkPlanOn: false,
        // 「つける」のときに選んでいる飲み放題の ID
        selectedDrinkPlanId: null,
        // 各飲み放題に入れる人数 {id: 人数}。人数・つける／つけない・選択が変わるたびに作り直し、子(DrinkPlanOption)に渡す
        drinkPlanQuantities: {},
        // スタッフ付き(ケータリング)にしたときの計算結果(料理のみ)。オードブルのときだけ使う
        cateringEstimate: null,
        // 1つ上のプランにしたときの計算結果(今と同じ条件)。「1つ上のプランにすると＋○円」用
        upgradeEstimate: null,
        // 前のプランの画面から引き継いだ追加料理・ドリンク・ドリンクセット {dishes, drinks, drink_sets}。無ければ null
        carried: null,
        drinkAvailable: false,
        shouldShowEstimateModal: false,
        shouldShowOrderCautionModal: false,
        disabledDates: {
          to: moment().toDate(), // Disable all dates up to specific date
          // 年末年始休業(毎年 12/31〜1/3)は選べない。休業日の一覧は props(yearEndHolidays)で受け取る
          customPredictor: (date) => this.isYearEndHoliday(date),
        },
        orderTypeJa,
        mealTypeJa,
        ja: ja,
        errors: {
          messages: {
            quantity: [],
          },
          fullMessages: []
        },
        plan: {},
        drinkSetOptions: [],
        drinkPlanOptions: [],
        drinkOptions: [],
        dishOptions: [],
        // 流入経路（どこで知ったか）の選択肢。値は Order の enumerize と一致させること
        referralSourceOptions: [
          { value: 'search',         label: 'Google・Yahooなどの検索' },
          { value: 'ad',             label: '広告（ネット広告・チラシなど）' },
          { value: 'ai',             label: 'ChatGPTなどのAIにすすめられた' },
          { value: 'sns',            label: 'SNS（Instagram・YouTube など）' },
          { value: 'referral',       label: '知人・取引先の紹介' },
          { value: 'repeat_use',     label: '以前に利用した（リピート）' },
          { value: 'internal_share', label: '社内で共有されていた' },
          { value: 'other',          label: 'その他' },
        ],
        calculationResult: {
          total_price: 0,
          delivery_price: 0,
          delivery_regular_price: 0,
          need_to_be_free_delivery: 0,
          dishes: [],
          drink_plans: [],
          customizations: [],
          worker: { quantity: 0, price: 0, unit_price: 7500 },
          plate: { quantity: 0, price: 0, unit_price: 30 },
          exothermic_agent: { quantity: 0, price: 0, unit_price: 300 },
          tablecloth: { quantity: 0, price: 0, unit_price: 1000 },
          reduced_tax_rate: { sub_total: 0, tax: 0 },
          normal_tax_rate: { sub_total: 0, tax: 0 },
          // 100名以上の大口特典(サーバの OrderCalculationService が計算する)
          large_order: {
            eligible: false, staff_free: false, staff_label: '', staff_regular_price: 0,
            tablecloth_free: false, tablecloth_regular_price: 0, plate_free: false, plate_regular_price: 0,
            sushi_more: false, early_discount: 0, early_discount_label: '', lines: []
          }
        },
        loading: false,
        about_venue: '',
        catering_parking: '',
        order: {
          order_type: '',
          plan_name: '',
          plan_price: '',
          quantity: '',
          plate_quantity: '',
          use_plate: false, // 取皿
          use_exothermic_agent: false, // 発熱剤
          use_tablecloth: false, // テーブルクロス
          prefecture: '',
          city: '',
          address: '',
          building_name: '',
          email: '',
          group_name: '',
          customer_name: '',
          payment_method: '',
          scene: '', // ご利用シーン(任意)
          scene_note: '', // ご利用シーン(その他)の自由記述
          // 配達日はここで宣言しておかないと Vue が変更を検知できず、
          // ご利用シーンの季節の選択肢が切り替わらない(Vue2 の仕様)
          catering_on: null,
          delivery_on: null,
          referral_source: '', // どこで知ったか(任意)
          referral_source_note: '', // どこで知ったか(その他)の自由記述
          photo_consent: false, // 料理・会場の撮影OK(任意)
          pro_photo_request: false, // プロカメラマンの記念撮影の希望(ケータリングのみ)
          pro_photo_note: '', // プロ撮影の要望(入場時間など)
          need_receipt: null,
          receipt_proviso: '',
          receipt_address: '',
          catering_start_at: '',
          catering_end_at: '',
          delivery_time_range: '',
          catering_admission_procedure: '', // 入館手続き'
          catering_elevator: '', // エレベーター
          catering_wagon: '', // 台車
          catering_parking: '', // 駐車場
          catering_parking_fee: '', // 駐車場料金
          catering_solid_fuel_using: '', // 固形燃料の使用'
          catering_avalilable_time: '', // 入室可能時間'
          catering_backdown_time: '', // 撤収時刻'
          catering_remarks: '', //会場についての補足情報
          alcohol_policy_agreement: false,
          drinks: [],
          drink_plans: [],
          drink_sets: [],
          dishes: [],
          plans: [],
          customizations: [],
        },
      }
    },
    computed: {
      // 年末年始休業の日の一覧('月-日')。props が無ければ予備の値(サーバー側と同じ)
      yearEndHolidayKeys() {
        return Array.isArray(this.yearEndHolidays) ? this.yearEndHolidays : YEAR_END_HOLIDAY_FALLBACK
      },
      // 配達日の下の注意書き。休業日が無ければ出さない
      yearEndHolidayNote() {
        if (this.yearEndHolidayKeys.length === 0) return null
        const label = this.yearEndHolidayLabel || YEAR_END_HOLIDAY_LABEL_FALLBACK
        return `※年末年始休業（${label}）はお選びいただけません。`
      },
      submitable() {
        const { quantity } = this.errors.messages
        // const { fullMessages } = this.errors
        return quantity.length === 0
      },
      isSeventeenPassed() {
        return moment().isAfter(moment().hour(17).minute(0).seconds(0))
      },
      // ドリンクプランで「同じ系統の時間数違い」を選択した場合にエラーメッセージを表示
      invalidDrinkPlanCombinationMessages() {
        const { drink_plans: drinkPlans } = this.order
        if (drinkPlans.length === 0) return []
        const drinkPlanNames = drinkPlans.filter(drinkPlan => drinkPlan.quantity > 0).map(drinkPlan => drinkPlan.name.split(' ')[0])
        const drinkPlanTimes = drinkPlans.filter(drinkPlan => drinkPlan.quantity > 0).map(drinkPlan => drinkPlan.name.split(' ')[1])
        let messages = []
        if (drinkPlanNames.includes('格安飲み放題') && drinkPlanNames.includes('ビール飲み放題')) {
          messages.push('「格安飲み放題」と「ビール飲み放題」を組み合わせることが出来ません。');
        } else if (drinkPlanTimes.includes('2時間') && drinkPlanTimes.includes('3時間')) {
          messages.push('ドリンクプランの「2時間」と「3時間」を組み合わせることが出来ません。');
        }
        return messages
      },
      drinkPlanMinimumQuantityWarning() {
        const { quantity, drink_plans: drinkPlans } = this.order
        let drinkPlanTotalQuantity
        if (drinkPlans.length === 0) {
          drinkPlanTotalQuantity = 0
        } else {
          drinkPlanTotalQuantity = drinkPlans.map(drinkPlan => drinkPlan.quantity).reduce((total, quantity) => total + quantity)
        }
        return quantity && drinkPlanTotalQuantity != 0 && drinkPlanTotalQuantity < quantity
      },
      // 100名以上特典の1行の案内。サーバが特典の対象と判定した(人数100名以上・軽食プラン以外)注文で、
      // /large/ のボタンから来ていないときだけ。中身はプランの種類で変わるので、実際に付いた特典の名前を並べる
      largeOrderNotice() {
        const benefit = this.calculationResult.large_order || {}
        if (!benefit.eligible || this.order.large_order_page_referral) return null
        const names = []
        if (benefit.early_discount > 0) names.push('早割3%')
        if (benefit.tablecloth_free) names.push('テーブルクロス0円')
        if (benefit.plate_free) names.push('取皿セット0円')
        if (benefit.sushi_more) names.push('お寿司増量')
        return names.length > 0 ? names.join('・') : null
      },
      // 1つ上のプランの最低人数(飲み放題を付けていればそちらの最低人数)
      upgradeMinimumQuantity() {
        const up = this.upgradePlan
        if (!up) return 0
        const withDrink = this.order.order_type === 'catering' && (this.order.drink_plans || []).some(d => Number(d.quantity) > 0)
        return Number((withDrink && up.minimum_quantity_with_drink_plan) || up.minimum_quantity || 0)
      },
      // 「1つ上のプランにすると＋○円」を出すか。1つ上のプランがあり、人数がその最低人数以上で、両方の計算ができていて、
      // 上のプランの方が高いとき。1人あたりはプランの単価の差(税抜)、合計は見積りの合計金額の差(税込)
      planUpgrade() {
        const up = this.upgradePlan
        const quantity = Number(this.order.quantity) || 0
        if (!up || quantity <= 0 || quantity < this.upgradeMinimumQuantity) return null
        const current = Number(this.calculationResult.total_price) || 0
        const target = this.upgradeEstimate && Number(this.upgradeEstimate.total_price)
        if (!current || !target || this.upgradeEstimate.quantity !== quantity) return null
        const diff = target - current
        const diffPerPerson = Number(up.price) - Number(this.order.plan_price)
        if (diff <= 0 || diffPerPerson <= 0) return null
        // 押したら人数と飲み放題(つける／つけない)をそのまま引き継いで 1つ上のプランの注文画面を開く
        const params = [`plan_id=${up.plan_id}`, `quantity=${quantity}`]
        if (this.order.order_type === 'catering') {
          // order.drink_plans には ID が無い(名前だけ)ので、選択肢(drinkPlanOptions)から名前で ID を引く
          const used = (this.order.drink_plans || []).find(d => Number(d.quantity) > 0)
          const option = used && (this.drinkPlanOptions || []).find(o => o.name === used.name)
          params.push(option ? `drink_plan_id=${option.id}` : 'drink=none')
        }
        if (this.order.large_order_page_referral) params.push('large_order_page=1')
        params.push('carry=1') // 住所などの入力内容を引き継ぐ(sessionStorage。trackPlanUpgrade で保存)
        return { diff, diffPerPerson, url: `/orders/new?${params.join('&')}` }
      },
      // 「スタッフ付きも選べます」を出すか。オードブルで、人数がケータリングの最低人数以上で、両方の計算ができているとき
      cateringSuggestion() {
        const alt = this.cateringAlternative
        const quantity = Number(this.order.quantity) || 0
        if (this.order.order_type !== 'delivery' || !alt || quantity < Number(alt.minimum_quantity || 0)) return null
        const current = Number(this.calculationResult.total_price) || 0
        const target = this.cateringEstimate && Number(this.cateringEstimate.total_price)
        if (!current || !target || this.cateringEstimate.quantity !== quantity) return null
        const diff = target - current
        return {
          total: target,
          diff,
          diffPerPerson: Math.round(diff / quantity),
          url: `/orders/new?plan_id=${alt.plan_id}&quantity=${quantity}`
        }
      },
      // 最小注文人数
      minimumQuantity() {
        const { drink_plans: drinkPlans, minimum_quantity: minimumQuantity, minimum_quantity_with_drink_plan: minimumQuantityWithDrinkPlan } = this.order
        if (drinkPlans.length === 0) return minimumQuantity
        if (drinkPlans.filter(drinkPlan => drinkPlan.quantity > 0).length > 0) {
          return minimumQuantityWithDrinkPlan
        } else {
          return minimumQuantity
        }
      },
      // 追加料理の最小注文人数
      dishMinimumQuantity() {
        var minimum = Math.ceil(this.order.quantity / 2);
        return minimum = minimum <= 10  ? 10 : minimum;
      },
      // ご利用シーンの選択肢。季節ものは、お客様が選んだ配達日の月のときだけ出す
      sceneOptions() {
        const date = this.order.catering_on || this.order.delivery_on
        const month = date ? new Date(date).getMonth() + 1 : null
        return (this.sceneOptionList || []).filter(opt => !opt.months || (month && opt.months.includes(month)))
      },
      filteredDeliveryPriceTable() {
        return this.deliveryPriceTable.filter((element) => {
          return element.attributes.prefecture == this.order.prefecture
        })
      },
    },
    watch: {
      // 催事日を変えたら金額を計算し直す(100名以上の早期ご予約割は催事日までの日数で変わるため)
      'order.catering_on'() {
        if (this.order.plan_id) this.calculate()
      },
      // 人数・飲み放題の「つける／つけない」・選んだ飲み放題が変わったら、飲み放題の人数をそろえ直す
      'order.quantity'() { this.syncDrinkPlanQuantities(); this.fetchCateringEstimate() },
      'order.city'() { this.fetchCateringEstimate() },
      'order.prefecture'() { this.fetchCateringEstimate() },
      'order.delivery_on'() { this.fetchCateringEstimate() },
      drinkPlanOn() { this.syncDrinkPlanQuantities() },
      selectedDrinkPlanId() { this.syncDrinkPlanQuantities() },
      'order.delivery_on'() {
        if (this.order.plan_id) this.calculate()
      },
      // 「その他」以外を選び直したときは自由記述を破棄する
      'order.referral_source'(value) {
        if (value !== 'other') this.order.referral_source_note = ''
      },
      'order.scene'(value) {
        if (value !== 'other') this.order.scene_note = ''
      },
      // 撮影OKを外したらプロ撮影の希望と要望も消す(1を外しても2が残らないように)
      'order.photo_consent'(value) {
        if (!value) {
          this.order.pro_photo_request = false
          this.order.pro_photo_note = ''
        }
      },
      'order.pro_photo_request'(value) {
        if (!value) this.order.pro_photo_note = ''
      },
      // 配達日を変えると季節の選択肢が入れ替わるので、
      // 選べなくなった項目(12月→6月にしたときの「忘年会」など)が残らないようにする
      sceneOptions(options) {
        const current = this.order.scene
        if (current && !options.some(opt => opt.value === current)) {
          this.order.scene = ''
          this.order.scene_note = ''
        }
      },
    },
  methods: {
      /**
       * Google Analytics の _ga クッキーから client_id を取得
       * @returns {string|null} client_id (例: "123456789.1234567890") または null
       */
      getGaClientId() {
        // _gaクッキーを検索（末尾のセミコロンも考慮）
        const match = document.cookie.match(/_ga=([^;]+)/);
        
        if (match && match[1]) {
          // _gaの値は "GA1.2.123456789.1234567890" の形式
          // "123456789.1234567890" の部分を抽出
          const parts = match[1].split('.');
          
          if (parts.length >= 4) {
            // 最後の2つの部分を結合してclient_idとする
            return `${parts[2]}.${parts[3]}`;
          }
        }
        
        // _gaクッキーが見つからない、または形式が不正な場合
        return null;
      },
      // 年末年始休業の日か(年に関係なく「月-日」で見る。カレンダーで灰色にする)
      isYearEndHoliday(date) {
        return this.yearEndHolidayKeys.includes(`${date.getMonth() + 1}-${date.getDate()}`)
      },
      validatesQuantity() {
        this.errors.messages.quantity = [];
        const { quantity } = this.order
        if (quantity === '') return;
        if (this.order.quantity < this.minimumQuantity) {
          this.errors.messages.quantity.push(`${this.minimumQuantity}人以上の注文が必要です。`)
        }
        // 注文できる上限(2026-10-10 maki さん指示): ケータリング 800名 / オードブル 1,000名。超えたら電話で相談
        if (this.order.order_type === 'catering') {
          if (quantity > 800) this.errors.messages.quantity.push('801人以上の場合は電話でお問い合わせください')
        } else {
          if (quantity > 1000) this.errors.messages.quantity.push('1001人以上の場合は電話でお問い合わせください')
        }
      },
      updatePlateQuantity() {
        const { plate_quantity: plateQuantity, quantity } = this.order
        this.order.plate_quantity = quantity
      },
      // 都道府県を変えたら市区を選び直してもらう(前の都道府県の市区が残ったまま送られ、送料が 0 円で計算されていた)
      changePrefecture() {
        this.order.city = ''
        this.calculate()
      },
      calculate() {
        axios.get('/api/orders/calculate', {
            params: this.params(),
            paramsSerializer: (params) => {
              return qs.stringify(params, { arrayFormat: 'brackets' })
            }
          },
        ).then((res) => {
          this.calculationResult = res.data
        });
        // 同じ条件で 1つ上のプランも計算する(「1つ上のプランにすると＋○円」用)
        this.fetchUpgradeEstimate()
      },
      showEstimateModal() {
        this.shouldShowEstimateModal = true;
      },
      hideEstimateModal() {
        this.shouldShowEstimateModal = false;
      },
      showOrderCautionModal() {
        this.shouldShowOrderCautionModal = true;
      },
      hideOrderCautionModal() {
        this.shouldShowOrderCautionModal = false;
      },
      downloadEstimate() {
        this.loading = true;
        axios.get('/api/orders/download_estimate', {
            responseType: 'blob',
            params: this.params(),
            paramsSerializer: (params) => {
              return qs.stringify(params, { arrayFormat: 'brackets' })
            }
          }
        ).then(response => {
            this.loading = false;

            // タイムスタンプ生成
            const now = new Date();
            const timestamp = now.getFullYear() +
              String(now.getMonth() + 1).padStart(2, '0') +
              String(now.getDate()).padStart(2, '0') + '_' +
              String(now.getHours()).padStart(2, '0') +
              String(now.getMinutes()).padStart(2, '0') +
              String(now.getSeconds()).padStart(2, '0');
            
            const fileName = `estimate_${timestamp}.pdf`;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            this.loading = false;
            console.log(error)
          });
      },
      create(e) {
        this.loading = true;
        e.preventDefault()
        axios.post('/api/orders', this.params())
          .then(response => {
            this.loading = false;
            window.location = '/orders/complete';
          })
          .catch(error => {
            console.log(error)
            this.loading = false;
            this.hideOrderCautionModal()
            window.scrollTo(0,0);
            // 400 以外(サーバーエラー・通信エラー)は errors が無いので、何も表示されずに止まらないよう一言出す
            const response = error.response
            const messages = response && response.data && response.data.errors && response.data.errors.full_messages
            this.errors.fullMessages = (messages && messages.length > 0)
              ? messages
              : ['送信に失敗しました。しばらくしてからもう一度お試しください。改善しない場合はお電話（050-5434-9753）でご連絡ください。']
          });
      },
      isCustomizationSelected(planCustomizationId) {
        const target = this.plan.customizations.find(pc => pc.id === planCustomizationId)
        if (!target) return false
        return this.order.customizations.some(c =>
          c.plan_customization_id === planCustomizationId || c.description === target.description
        )
      },
      handleCustomization(customization, checked) {
        const { customizations } = this.order
        const matches = c =>
          c.plan_customization_id === customization.id || c.description === customization.description
        if (checked) {
          if (!customizations.some(matches)) {
            this.order.customizations = [
              ...customizations,
              {
                plan_customization_id: customization.id,
                description: customization.description,
                price: customization.price
              }
            ]
          }
        } else {
          this.order.customizations = customizations.filter(c => !matches(c))
        }
        this.calculate()
      },
      // 日付の入力値(Datepicker の Date、または編集時に API から来る '2026-11-10' の文字)を '年-月-日' の文字にそろえる。空なら空のまま
      dateParam(value) {
        if (!value) return value
        const m = moment(value)
        return m.isValid() ? m.format('YYYY-MM-DD') : value
      },
      params() {
        const { customizations, drinks, drink_sets: drinkSets, drink_plans: drinkPlans, dishes } = this.order

        // GA4のclient_idを取得
        const gaClientId = this.getGaClientId();

        const params = {
          order: {
            // NOTE: プラン由来の情報(plan_type/plan_name/plan_price/order_type/meal_type/最低注文人数など)は
            // サーバ側でplan_idから確定するため送らない
            plan_id: this.order.plan_id,
            quantity: this.order.quantity,
            plate_quantity: this.order.plate_quantity,
            use_plate: this.order.use_plate,
            use_exothermic_agent: this.order.use_exothermic_agent,
            use_tablecloth: this.order.use_tablecloth,
            prefecture: this.order.prefecture,
            city: this.order.city,
            address: this.order.address,
            building_name: this.order.building_name,
            email: this.order.email,
            group_name: this.order.group_name,
            customer_name: this.order.customer_name,
            tel: this.order.tel,
            payment_method: this.order.payment_method,
            scene: this.order.scene,
            scene_note: this.order.scene_note,
            referral_source: this.order.referral_source,
            referral_source_note: this.order.referral_source_note,
            photo_consent: this.order.photo_consent,
            pro_photo_request: this.order.pro_photo_request,
            pro_photo_note: this.order.pro_photo_note,
            invoice_address: this.order.invoice_address,
            need_receipt: this.order.need_receipt,
            receipt_proviso: this.order.receipt_proviso,
            receipt_address: this.order.receipt_address,
            request: this.order.request,
            // 日付は「年-月-日」の文字だけ送る。Date のまま送ると世界標準時に直されて、
            // 午前9時より前に選んだ日付が前日として保存されてしまうため(2026-10-06 本番で実測)
            delivery_on: this.dateParam(this.order.delivery_on),
            delivery_time_range: this.order.delivery_time_range,
            catering_on: this.dateParam(this.order.catering_on),
            catering_start_at: this.order.catering_start_at,
            catering_end_at: this.order.catering_end_at,
            catering_admission_procedure: this.order.catering_admission_procedure,
            catering_elevator: this.order.catering_elevator,
            catering_wagon: this.order.catering_wagon,
            catering_parking: this.order.catering_parking,
            catering_parking_fee: this.order.catering_parking_fee,
            catering_solid_fuel_using: this.order.catering_solid_fuel_using,
            catering_avalilable_time: this.order.catering_avalilable_time,
            catering_backdown_time: this.order.catering_backdown_time,
            catering_remarks: this.order.catering_remarks,
            alcohol_policy_agreement: this.order.alcohol_policy_agreement,
            // 100名以上向けのページのボタンから来たか(スタッフ料金0円の特典の条件)
            large_order_page_referral: this.order.large_order_page_referral,
            ga_client_id: gaClientId, // GA4のclient_idを追加
            customizations_attributes: customizations.map(customization => {
              return {
                id: customization.id,
                description: customization.description,
                price: customization.price
              }
            }),
            drinks_attributes: drinks.map(drink => {
              return {
                id: drink.id,
                name: drink.name,
                kind: drink.kind,
                price: drink.price,
                quantity: drink.quantity,
                unit_name: drink.unit_name
              }
            }),
            drink_plans_attributes: drinkPlans.map(drinkPlan => {
              return {
                id: drinkPlan.id,
                name: drinkPlan.name,
                price: drinkPlan.price,
                quantity: drinkPlan.quantity,
                unit_name: drinkPlan.unit_name,
                customizations_attributes: (drinkPlan.customizations || []).map(customization => {
                  return {
                    id: customization.id,
                    drink_plan_customization_id: customization.drink_plan_customization_id,
                    description: customization.description,
                    price: customization.price
                  }
                })
              }
            }),
            drink_sets_attributes: drinkSets.map(drinkSet => {
              return {
                id: drinkSet.id,
                name: drinkSet.name,
                price: drinkSet.price,
                quantity: drinkSet.quantity,
                content: drinkSet.content
              }
            }),
            dishes_attributes: dishes.map(dish => {
              return {
                id: dish.id,
                name: dish.name,
                price: dish.price,
                quantity: dish.quantity,
                unit_name: dish.unit_name
              }
            }),
          }
        }
        return params
      },
      handleDrink(selectedDrink) {
        const { drinks } = this.order
        const { name, unit_name, kind, price, quantity } = selectedDrink
        const drink = drinks.find(drink => drink.name === selectedDrink.name && drink.price === selectedDrink.price);
        if (drink) {
          const index = drinks.indexOf(drink);
          if(quantity === 0 || quantity === '') {
            this.order.drinks = [
              ...drinks.slice(0, index),
              ...drinks.slice(index + 1),
            ];
          } else {
            this.order.drinks = [
              ...drinks.slice(0, index),
              { ...drink, quantity },
              ...drinks.slice(index + 1),
            ];
          }
        } else {
          this.order.drinks = [...drinks, { name, unit_name, kind, price, quantity }]
        }
      },
      handleDrinkSet(selectedDrinkSet) {
        const { drink_sets: drinkSets } = this.order
        const drinkSet = drinkSets.find(drinkSet => drinkSet.name === selectedDrinkSet.name);
        const { name, price, quantity } = selectedDrinkSet
        if (drinkSet) {
          const index = drinkSets.indexOf(drinkSet);
          if(quantity === 0 || quantity === '') {
            this.order.drink_sets = [
              ...drinkSets.slice(0, index),
              ...drinkSets.slice(index + 1),
            ];
          } else {
            this.order.drink_sets = [
              ...drinkSets.slice(0, index),
              { ...drinkSet, quantity },
              ...drinkSets.slice(index + 1),
            ];
          }
        } else {
          this.order.drink_sets = [...drinkSets, { name, price, quantity }]
        }
      },
      handleDrinkPlan(selectedDrinkPlan) {
        const { drink_plans: drinkPlans } = this.order
        const drinkPlan = drinkPlans.find(drinkPlan => drinkPlan.name === selectedDrinkPlan.name);
        const { name, unit_name, price, quantity, customizations = [] } = selectedDrinkPlan
        if (drinkPlan) {
          const index = drinkPlans.indexOf(drinkPlan);
          if(quantity === 0 || quantity === '') {
            this.order.drink_plans = [
              ...drinkPlans.slice(0, index),
              ...drinkPlans.slice(index + 1),
            ];
          } else {
            this.order.drink_plans = [
              ...drinkPlans.slice(0, index),
              { ...drinkPlan, quantity, customizations },
              ...drinkPlans.slice(index + 1),
            ];
          }
        } else {
          if(quantity === 0 || quantity === '') return
          this.order.drink_plans = [...drinkPlans, { name, unit_name, price, quantity, customizations }]
        }
      },
      handleDish(selectedDish) {
        const { dishes } = this.order
        const { name, unit_name, price, quantity } = selectedDish
        const dish = dishes.find(dish => dish.name === selectedDish.name && dish.price === selectedDish.price);
        if (dish) {
          const index = dishes.indexOf(dish);
          if(quantity === 0 || quantity === '') {
            this.order.dishes = [
              ...dishes.slice(0, index),
              ...dishes.slice(index + 1),
            ];
          } else {
            this.order.dishes = [
              ...dishes.slice(0, index),
              { ...dish, quantity },
              ...dishes.slice(index + 1),
            ];
          }
        } else {
          const index = dishes.indexOf(dish);
          this.order.dishes = [...dishes, { name, unit_name, price, quantity }]
        }
      },
      // 同じ条件(人数・配達先・日付)で、スタッフ付き(ケータリング)にしたときの金額を計算する(料理のみ・ドリンクなし)。
      // 少し待ってから呼び、人数を打っている途中で何度も計算しない
      fetchCateringEstimate() {
        const alt = this.cateringAlternative
        const quantity = Number(this.order.quantity) || 0
        if (this.order.order_type !== 'delivery' || !alt || quantity < Number(alt.minimum_quantity || 0)) {
          this.cateringEstimate = null
          return
        }
        clearTimeout(this.cateringEstimateTimer)
        this.cateringEstimateTimer = setTimeout(() => {
          const params = this.params()
          params.order = {
            ...params.order,
            plan_id: alt.plan_id,
            quantity,
            use_plate: false, plate_quantity: null, use_exothermic_agent: false, use_tablecloth: false,
            catering_on: params.order.delivery_on, delivery_on: null,
            drinks_attributes: [], drink_sets_attributes: [], drink_plans_attributes: [],
            dishes_attributes: [], customizations_attributes: []
          }
          axios.get('/api/orders/calculate', {
            params,
            paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'brackets' })
          }).then((res) => {
            this.cateringEstimate = { ...res.data, quantity }
          }).catch(() => { this.cateringEstimate = null })
        }, 400)
      },
      // 今の見積りと同じ条件(人数・飲み放題・追加料理など)で、1つ上のプランにしたときの金額を計算する。
      // 料理内容変更(customizations)はプランごとの項目なので外す。少し待ってから呼び、人数を打っている途中で何度も計算しない
      fetchUpgradeEstimate() {
        const up = this.upgradePlan
        const quantity = Number(this.order.quantity) || 0
        if (!up || quantity <= 0) {
          this.upgradeEstimate = null
          return
        }
        clearTimeout(this.upgradeEstimateTimer)
        this.upgradeEstimateTimer = setTimeout(() => {
          const params = this.params()
          params.order = { ...params.order, plan_id: up.plan_id, customizations_attributes: [] }
          axios.get('/api/orders/calculate', {
            params,
            paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'brackets' })
          }).then((res) => {
            this.upgradeEstimate = { ...res.data, quantity }
          }).catch(() => { this.upgradeEstimate = null })
        }, 400)
      },
      // 「○○プランで見積りを見る」を押す直前に、入力した内容(住所・日付・会場情報・追加料理など)をブラウザに一時保存する。
      // 保存できなくても(プライベートモード等)画面は進む。人数と飲み放題は URL で渡す
      savePlanUpgradeCarry() {
        try {
          const fields = {}
          PLAN_UPGRADE_CARRY_FIELDS.forEach((key) => { fields[key] = this.order[key] })
          const carry = {
            order_type: this.order.order_type,
            saved_at: Date.now(),
            fields,
            about_venue: this.about_venue,
            dishes: this.order.dishes || [],
            drinks: this.order.drinks || [],
            drink_sets: this.order.drink_sets || []
          }
          window.sessionStorage.setItem(PLAN_UPGRADE_CARRY_KEY, JSON.stringify(carry))
        } catch (e) { /* 保存は任意 */ }
      },
      // ?carry=1 で開いたとき、前の画面で保存した入力内容を戻す(一度戻したら消す)。注文の種類が違うときは戻さない
      restorePlanUpgradeCarry() {
        try {
          const raw = window.sessionStorage.getItem(PLAN_UPGRADE_CARRY_KEY)
          if (!raw) return
          window.sessionStorage.removeItem(PLAN_UPGRADE_CARRY_KEY)
          const carry = JSON.parse(raw)
          if (!carry || carry.order_type !== this.order.order_type) return
          if (Date.now() - Number(carry.saved_at || 0) > 60 * 60 * 1000) return // 1時間より前のものは使わない
          PLAN_UPGRADE_CARRY_FIELDS.forEach((key) => {
            const value = (carry.fields || {})[key]
            if (value !== undefined && value !== null) this.$set(this.order, key, value)
          })
          if (carry.about_venue) this.about_venue = carry.about_venue
          this.carried = { dishes: carry.dishes || [], drinks: carry.drinks || [], drink_sets: carry.drink_sets || [] }
        } catch (e) { /* 戻せなくても画面は進む */ }
      },
      // 引き継いだ追加料理・ドリンク・ドリンクセットの数(名前と単価が同じもの)。無ければ null(空欄)
      carriedQuantity(kind, option) {
        if (!this.carried) return null
        const found = (this.carried[kind] || []).find(item => item.name === option.name && Number(item.price) === Number(option.price))
        const quantity = found ? Number(found.quantity) : 0
        return quantity > 0 ? quantity : null
      },
      // 「○○プランで見積りを見る」を押した回数を GA4 に送る(効果を測るため)。送れなくても画面は進む
      trackPlanUpgrade() {
        this.savePlanUpgradeCarry()
        try {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'plan_upgrade_click',
            plan_name: this.order.plan_name,
            upgrade_plan_name: this.upgradePlan && this.upgradePlan.name,
            quantity: Number(this.order.quantity) || 0
          })
        } catch (e) { /* 計測は任意 */ }
      },
      // 「スタッフ付きで見積りを見る」を押した回数を GA4 に送る(効果を測るため)。送れなくても画面は進む
      trackCateringSuggestion() {
        try {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ event: 'catering_suggestion_click', plan_name: this.order.plan_name, quantity: Number(this.order.quantity) || 0 })
        } catch (e) { /* 計測は任意 */ }
      },
      // 「つける」なら選んだ飲み放題にお料理と同じ人数、それ以外は 0。「つけない」なら全部 0
      syncDrinkPlanQuantities() {
        if (this.order.order_type !== 'catering') return
        const quantity = Number(this.order.quantity) || 0
        const result = {}
        this.drinkPlanOptions.forEach((drinkPlan) => {
          const on = this.drinkPlanOn && Number(drinkPlan.id) === Number(this.selectedDrinkPlanId)
          result[drinkPlan.id] = on ? quantity : 0
        })
        this.drinkPlanQuantities = result
      },
      syncedDrinkPlanQuantity(drinkPlan) {
        const value = this.drinkPlanQuantities[drinkPlan.id]
        return value === undefined ? null : value
      },
      // 引き継いだ飲み放題と同じ ID の選択肢にだけ人数を入れる。それ以外は null(空欄)
      prefillDrinkPlanQuantity(drinkPlan) {
        const prefill = this.prefillDrinkPlan
        if (!prefill || !prefill.id || !(prefill.quantity > 0)) return null
        return Number(prefill.id) === Number(drinkPlan.id) ? Number(prefill.quantity) : null
      },
      fetchDrinks() {
        axios.get('/api/drinks').then((res) => {
          this.drinkOptions = res.data;
        });
      },
      fetchDrinkPlans() {
        axios.get('/api/drink_plans').then((res) => {
          this.drinkPlanOptions = res.data;
          // 「つける」で開いたのに選択が無い(引き継いだ ID が一覧に無い等)ときは先頭を選ぶ
          if (this.drinkPlanOn && !this.drinkPlanOptions.some(d => Number(d.id) === Number(this.selectedDrinkPlanId))) {
            this.selectedDrinkPlanId = this.drinkPlanOptions.length ? this.drinkPlanOptions[0].id : null
          }
          this.syncDrinkPlanQuantities()
        });
      },
      fetchDrinkSets() {
        axios.get('/api/drink_sets').then((res) => {
          this.drinkSetOptions = res.data;
        });
      },
      fetchDishes() {
        axios.get('/api/dishes').then((res) => {
          this.dishOptions = res.data;
        });
      },
      fetchOrder(id) {
        return axios.get(`/api/orders/${id}`).then((res) => {
          this.order = { ...this.order, ...res.data }
        });
      },
      fetchPlan(id) {
        return axios.get(`/api/plans/${id}`).then((res) => {
          this.plan = res.data;
        });
      },
      timeOptions(start, end) {
        var options = []
        _.range(start, end).forEach(h => {
          options.push(`${h}:00`)
          options.push(`${h}:15`)
          options.push(`${h}:30`)
          options.push(`${h}:45`)
        });
        options.push(`${end}:00`)
        return options
      },
      timeRangeOptions(start, end) {
        var options = []
        _.range(start, end).forEach(h => {
          options.push(`${h}:00 〜 ${h + 1}:00`)
          options.push(`${h}:15 〜 ${h + 1}:15`)
          options.push(`${h}:30 〜 ${h + 1}:30`)
          options.push(`${h}:45 〜 ${h + 1}:45`)
        });
        options.push(`${end}:00 〜 ${end + 1}:00 `)
        return options
      },
    },
    mounted() {
      const { plan_id: planId } = this.orderProps
      if (planId) this.fetchPlan(planId);
      this.fetchDrinks();
      this.fetchDrinkPlans();
      this.fetchDrinkSets();
      this.fetchDishes();
    },
    beforeCreate() {
    },
    created() {
      // 新規作成の場合はpropsから受け取り、編集の場合はfetchする
      const { id } = this.orderProps
      if (id) {
        this.fetchOrder(id)
      } else {
        this.order = { ...this.order, ...this.orderProps }
        // 「1つ上のプランで見積りを見る」から来たときは、前の画面の入力内容(住所など)を戻す
        if (new URLSearchParams(window.location.search).get('carry') === '1') this.restorePlanUpgradeCarry()
        // 飲み放題の初期状態(ケータリングだけ)。サーバーが選んだ飲み放題(既定 or URL の drink_plan_id)があれば「つける」
        if (this.order.order_type === 'catering' && this.prefillDrinkPlan && this.prefillDrinkPlan.id) {
          this.drinkPlanOn = true
          this.selectedDrinkPlanId = Number(this.prefillDrinkPlan.id)
        }
        if (this.currentCustomer) {
          const { email, tel, name, group_name: groupName } = this.currentCustomer;
          this.order.email = email;
          this.order.tel = tel;
          this.order.customer_name = name;
          this.order.group_name = groupName;
        }
        // おすすめプラン案内ページから人数を引き継いだときは、手入力したときと同じ処理を通して
        // 見積(小計)と最低人数のチェックを最初から表示する
        if (this.order.quantity) {
          this.updatePlateQuantity()
          this.validatesQuantity()
          this.calculate()
          this.fetchCateringEstimate()
        }
      }
    },
    updated() {
    },
  }
</script>
